import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { musinsaSnapClient } from '../musinsaSnapClient';
import { snapLikeApiPath } from './apiPath';

const PostSnapLikedRequestSchema = z
  .object({
    snapId: z.string(),
  })
  .describe('PostSnapLikedRequestSchema');

const PostSnapLikedResponseDataSchema = z
  .object({
    data: z.null().optional(),
  })
  .describe('PostSnapLikedResponseDataSchema');

export type PostSnapLikedRequest = z.infer<typeof PostSnapLikedRequestSchema>;
export type PostSnapLikedResponseData = z.infer<typeof PostSnapLikedResponseDataSchema>;
export type PostSnapLikedResponse = MusinsaStandardResponse<PostSnapLikedResponseData>;

export const postSnapLiked = (params: PostSnapLikedRequest) =>
  executeStandardRequest(() =>
    musinsaSnapClient.post<PostSnapLikedResponse>(snapLikeApiPath.snapLiked(params.snapId)),
  );
